import { Container, Grid } from "@mui/material";

import pre_designed_template1 from "../../../assests/Images/TemplateElement/pre_designed_template1.png";
import pre_designed_template2 from "../../../assests/Images/TemplateElement/pre_designed_template2.png";
import pre_designed_template3 from "../../../assests/Images/TemplateElement/pre_designed_template3.png";
import pre_designed_template4 from "../../../assests/Images/TemplateElement/pre_designed_template4.png";
import pre_designed_template5 from "../../../assests/Images/TemplateElement/pre_designed_template5.png";
import pre_designed_template6 from "../../../assests/Images/TemplateElement/pre_designed_template6.png";
import { DATE } from "../../../shared/constants.js";
import ImageTemplateBlue from "../ImageTemplate/ImageTemplateBlue";
import ImageTemplateCyan from "../ImageTemplate/ImageTemplateCyan";
import ImageTemplatePink from "../ImageTemplate/ImageTemplatePink";
import CardTemplate from "../PreDesinedTemplate/CardTemplate";
import TextTemplateBlue from "./TextTemplateBlue";
import TextTemplateCyan from "./TextTemplateCyan";
import TextTemplateWhite from "./TextTemplateWhite";

function RenderTemplate() {
  return (
    <>
      <Container sx={{ padding: "4px" }}>
        <Grid container spacing={1} alignItems="stretch">
          <Grid item xs={6} sm={6} md={4} lg={3} sx={{ display: "flex", padding: "0px" }}>
            <TextTemplateCyan />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} sx={{ display: "flex", padding: "0px" }}>
            <CardTemplate
              headingText="My favorite book in the world, although I haven’t read it yet..."
              date={DATE.JOURNAL_FORMAT}
              bgColor="#0ae2cd"
              headingColor="#ffffff"
              textColor="#000000"
              textSize={{ xs: "0.9rem", sm: "1rem", md: "1rem" }}
              imageTopLeft={pre_designed_template1}
              imageTopLeftStyle={{
                width: 70,
                height: 70,
                top: 10,
                left: 10,
                transform: "rotate(150deg)",
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} sx={{ display: "flex", padding: "0px" }}>
            <TextTemplateBlue />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} sx={{ display: "flex", padding: "0px" }}>
            <TextTemplateWhite />
          </Grid>

          {/* image templates starts */}

          <Grid
            item
            xs={6}
            sm={6}
            md={4}
            lg={3}
            sx={{ display: "flex", padding: "0px", marginTop: "0px" }}
          >
            <ImageTemplateCyan />
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            md={4}
            lg={3}
            sx={{ display: "flex", padding: "0px", marginTop: "0px" }}
          >
            <ImageTemplateBlue />
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            md={4}
            lg={3}
            sx={{ display: "flex", padding: "0px", marginTop: "0px" }}
          >
            <ImageTemplatePink />
          </Grid>

          {/* pre define templates starts */}

          <Grid item xs={6} sm={6} md={4} lg={3} sx={{ display: "flex", padding: "0px" }}>
            <CardTemplate
              headingText="My favorite book in the world, although I haven’t read it yet..."
              date={DATE.JOURNAL_FORMAT}
              bgColor="#0ae2cd"
              headingColor="#ffffff"
              textColor="#000000"
              textSize={{ xs: "0.9rem", sm: "1rem", md: "1rem" }}
              imageTopLeft={pre_designed_template1}
              imageTopLeftStyle={{
                width: 70,
                height: 70,
                top: 10,
                left: 10,
                transform: "rotate(150deg)",
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} sx={{ display: "flex", padding: "0px" }}>
            <CardTemplate
              headingText="“A grand adventure is about to begin”"
              author="- Winnie the Pooh"
              date={DATE.JOURNAL_FORMAT}
              bgColor="#0ae2cd"
              headingColor="#000000"
              textColor="#ffffff"
              textSize={{ xs: "0.8rem", sm: "1rem", md: "1rem" }}
              widthSize={{ xs: "80%", sm: "70%", md: "70%" }}
              imageTopLeft={pre_designed_template2}
              imageTopLeftStyle={{
                width: 70,
                height: 70,
                top: 10,
                left: 10,
                transform: "rotate(150deg)",
              }}
              headingMargin={{ xs: "70%", sm: "50%", md: "50%" }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} sx={{ display: "flex", padding: "0px" }}>
            <CardTemplate
              headingText="Half-way there!"
              date={DATE.JOURNAL_FORMAT}
              bgColor="#0ae2cd"
              headingColor="#000000"
              textColor="#ffffff"
              textSize={{ xs: "1.1rem", sm: "1.2rem", md: "1.2rem" }}
              widthSize={{ xs: "55%", sm: "55%", md: "55%" }}
              imageTopLeft={pre_designed_template3}
              imageTopLeftStyle={{
                width: 70,
                height: 70,
                top: 10,
                left: 10,
                transform: "rotate(150deg)",
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} sx={{ display: "flex", padding: "0px" }}>
            <CardTemplate
              headingText=""
              date={DATE.JOURNAL_FORMAT}
              bgColor="#0ae2cd"
              headingColor="#000000"
              textColor="#000000"
              imageTopLeft={pre_designed_template4}
              imageTopLeftStyle={{
                width: 70,
                height: 70,
                top: 10,
                left: 10,
                transform: "rotate(150deg)",
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} sx={{ display: "flex", padding: "0px" }}>
            <CardTemplate
              headingText="Meet the baby day!"
              date={DATE.JOURNAL_FORMAT}
              bgColor="#0ae2cd"
              headingColor="#ffffff"
              textColor="#000000"
              textSize={{ xs: "1.1rem", sm: "1.2rem", md: "1.2rem" }}
              widthSize={{ xs: "55%", sm: "55%", md: "55%" }}
              imageTopLeft={pre_designed_template5}
              imageTopLeftStyle={{
                width: 70,
                height: 70,
                top: 10,
                left: 10,
                transform: "rotate(150deg)",
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} sx={{ display: "flex", padding: "0px" }}>
            <CardTemplate
              headingText=""
              date={DATE.JOURNAL_FORMAT}
              bgColor="#0ae2cd"
              headingColor="#000000"
              textColor="#000000"
              imageTopLeft={pre_designed_template6}
              imageTopLeftStyle={{
                width: 70,
                height: 70,
                top: 10,
                left: 10,
                transform: "rotate(150deg)",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default RenderTemplate;
